<div class="row">
  <div class="col-md-5">
    <div class="table-responsive">
      <table class="table" id="lotto-game">
        <thead>
          <tr>
            <th style="width: 150px">{{ "GAME_LOGO" | translate }}</th>
            <th style="width: 200px">
              {{ "STATUS" | translate }}
            </th>
            <th style="width: 180px">
              {{ "PLACE_TO_FIGHT" | translate }}
            </th>
            <th style="width: 120px">
              {{ "SET_UP" | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let setting of Data.profit_sharing; let i = index">
            <tr>
              <td style="width: 150px; position: relative">
                <img
                  [src]="'https://corsproxy.io/?url=' + setting.game_logo"
                  [alt]="setting.game_code"
                  style="width: 116px; padding: 5px"
                  class="img-logo-shadow bg-primary rounded"
                />
                <small class="d-block opacity-50">{{ setting.game_code }}</small>
              </td>
              <td style="width: 200px">
                <div class="form-check form-check-inline text-danger">
                  <input
                    id="game_disable_{{ i }}"
                    type="radio"
                    class="form-check-input"
                    name="game_disable_{{ i }}"
                    [value]="false"
                    [(ngModel)]="setting.game_enable"
                  />
                  <label for="game_disable_{{ i }}" class="form-check-label">
                    {{ "DISABLE" | translate }}
                  </label>
                </div>
                <div class="form-check form-check-inline text-primary">
                  <input
                    id="game_enable_{{ i }}"
                    type="radio"
                    class="form-check-input"
                    name="game_enable_{{ i }}"
                    [value]="true"
                    [(ngModel)]="setting.game_enable"
                  />
                  <label for="game_enable_{{ i }}" class="form-check-label">
                    {{ "ENABLE" | translate }}
                  </label>
                </div>
              </td>

              <td class="text-end" style="width: 180px">
                <small class="d-block opacity-50">
                  {{ "RECEIVED" | translate }} = {{ setting.percent_parent }}%
                </small>
                <div>
                  <div class="input-group mb-1">
                    <span class="input-group-text">
                      {{ "PLACE_TO_FIGHT" | translate }}
                    </span>
                    <input
                      type="number"
                      class="form-control text-end"
                      [(ngModel)]="setting.percent_own"
                      (ngModelChange)="onChangePercent(setting.game_code)"
                      (keyup)="onChangePercent(setting.game_code)"
                      (keydown)="onChangePercent(setting.game_code)"
                      (keypress)="onChangePercent(setting.game_code)"
                      [max]="setting.percent_given"
                      step="0.5"
                      min="0"
                    />
                    <span class="input-group-text">%</span>
                  </div>
                  <div class="input-group">
                    <span class="input-group-text">
                      {{ "RELEASE" | translate }}
                    </span>
                    <input
                      type="number"
                      class="form-control text-end"
                      [value]="setting.percent_given"
                      readonly
                    />
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </td>
              <td>
                <button
                  class="btn btn-outline-primary"
                  (click)="onActiveLottoSetting(setting.game_code)"
                  [ngClass]="{ active: activeGame == setting.game_code }"
                >
                  {{ "SET_UP" | translate }} <i class="bi bi-arrow-bar-right"></i>
                </button>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
  <div class="col-md-7">
    <ng-container *ngFor="let setting of Data.profit_sharing; let i = index">
      <ng-container *ngIf="setting.lotto_amb_betlimit && activeGame == setting.game_code">
        {{
          "ALL_AMOUNT_ITEMS" | translate : { amount: setting.lotto_amb_betlimit?.current.length }
        }}
        <div class="overflow-auto position-relative pt-1" #slideLottoAmb>
          <div style="width: 4500px">
            <ng-container
              *ngFor="let gameLimit of setting.lotto_amb_betlimit.current; let k = index"
            >
              <button
                class="btn btn-outline-info me-1 mb-1"
                (click)="onActiveLottoSettingAmb(gameLimit.game_list_code)"
                [ngClass]="{ active: activeGameListCode == gameLimit.game_list_code }"
              >
                <div class="d-flex">
                  <div class="py-2">
                    <img
                      [src]="gameLimit.game_list_icon"
                      class="me-1"
                      width="25px"
                      height="25px"
                      alt
                    />
                  </div>
                  <div class="text-start">
                    {{ k + 1 }}. {{ gameLimit.game_list_name }}
                    <small class="d-block">{{ gameLimit.game_list_name_dec }}</small>
                  </div>
                </div>
              </button>
            </ng-container>
          </div>
        </div>
        <hr />
        <ng-container *ngFor="let gameLimit of setting.lotto_amb_betlimit.current; let k = index">
          <ng-container *ngIf="activeGameListCode == gameLimit.game_list_code">
            <div class="my-2">
              <img [src]="gameLimit.game_list_icon" class="me-1" width="25px" height="25px" alt />
              {{ gameLimit.game_list_name }} - {{ gameLimit.game_list_name_dec }}
            </div>
            <div class="row">
              <div class="col-md-10">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th style="width: 150px">{{ "PLAYING" | translate }}</th>
                        <th style="width: 200px">{{ "DISCOUNT" | translate }}</th>
                        <th style="width: 180px">{{ "MINIMUM_BET" | translate }}</th>
                        <th style="width: 120px">{{ "BET_MAXIMUM" | translate }}</th>
                        <th style="width: 120px">{{ "PAYOUT_PER_BAHT" | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngFor="let Limit of gameLimit.betlimit; let i = index">
                        <tr>
                          <td style="width: 150px; position: relative">
                            {{ Limit.key_play_name }}
                          </td>
                          <td style="width: 200px">
                            <div class="input-group">
                              <input
                                type="number"
                                class="form-control text-end"
                                [(ngModel)]="Limit.discount"
                                disabled
                              />
                              <span class="input-group-text">%</span>
                            </div>
                            <small class="d-block opacity-50 text-end">
                              {{ "CANNOT_BE_SET_UP_RIGHT_NOW" | translate }}
                            </small>
                          </td>

                          <td class="text-end" style="width: 180px">
                            <div class="input-group">
                              <input
                                type="number"
                                class="form-control text-end"
                                [(ngModel)]="Limit.min"
                                (ngModelChange)="onChangeLimitSettingAmb(setting.game_code)"
                                (keyup)="onChangeLimitSettingAmb(setting.game_code)"
                                (keydown)="onChangeLimitSettingAmb(setting.game_code)"
                                (keypress)="onChangeLimitSettingAmb(setting.game_code)"
                                [max]="setting.lotto_amb_betlimit.max[k]?.betlimit[i].max"
                                step="0.5"
                                min="0"
                              />
                              <span class="input-group-text">THB</span>
                            </div>
                            <small class="d-block opacity-50">
                              {{
                                "THE_MINIMUM_BET_FOR_THE_UPLINE_IS_AMOUNT_BAHT"
                                  | translate
                                    : { amount: setting.lotto_amb_betlimit.max[k]?.betlimit[i].min }
                              }}
                            </small>
                          </td>

                          <td class="text-end" style="width: 180px">
                            <div class="input-group">
                              <input
                                type="number"
                                class="form-control text-end"
                                [(ngModel)]="Limit.max"
                                (ngModelChange)="onChangeLimitSettingAmb(setting.game_code)"
                                (keyup)="onChangeLimitSettingAmb(setting.game_code)"
                                (keydown)="onChangeLimitSettingAmb(setting.game_code)"
                                (keypress)="onChangeLimitSettingAmb(setting.game_code)"
                                [max]="setting.lotto_amb_betlimit.max[k]?.betlimit[i].max"
                                step="0.5"
                                min="0"
                              />
                              <span class="input-group-text">THB</span>
                            </div>
                            <small class="d-block opacity-50">
                              {{
                                "UPLINE_BETS_A_MAXIMUM_OF_AMOUNT_BAHT"
                                  | translate
                                    : { amount: setting.lotto_amb_betlimit.max[k]?.betlimit[i].max }
                              }}
                            </small>
                          </td>

                          <td class="text-end" style="width: 180px">
                            <div class="input-group">
                              <input
                                type="number"
                                class="form-control text-end"
                                [(ngModel)]="Limit.payout"
                                (ngModelChange)="onChangeLimitSettingAmb(setting.game_code)"
                                (keyup)="onChangeLimitSettingAmb(setting.game_code)"
                                (keydown)="onChangeLimitSettingAmb(setting.game_code)"
                                (keypress)="onChangeLimitSettingAmb(setting.game_code)"
                                [max]="setting.lotto_amb_betlimit.max[k]?.betlimit[i].payout"
                                step="0.5"
                                min="0"
                              />
                              <span class="input-group-text">THB</span>
                            </div>
                            <small class="d-block opacity-50">
                              {{
                                "UPLINE_PAYS_UP_TO_AMOUNT_BAHT"
                                  | translate
                                    : {
                                        amount:
                                          setting.lotto_amb_betlimit.max[k]?.betlimit[i].payout
                                      }
                              }}
                            </small>
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!setting.lotto_amb_betlimit && activeGame == setting.game_code">
        {{ "GAME_SETTING_NOT_FOUND" | translate }}: {{ setting.game_code }}
      </ng-container>
    </ng-container>
  </div>
</div>
